// import React, {useContext, useEffect, useLayoutEffect, useState} from 'react';
// import PropTypes from 'prop-types';
// import {useTranslation} from 'react-i18next';
// import classNames from 'classnames';
// import Button from '../../../components/bootstrap/Button';
// import {HeaderRight} from '../../../layout/Header/Header';
// import OffCanvas, {OffCanvasBody, OffCanvasHeader, OffCanvasTitle,} from '../../../components/bootstrap/OffCanvas';
// import Alert from '../../../components/bootstrap/Alert';
// import Dropdown, {DropdownItem, DropdownMenu, DropdownToggle,} from '../../../components/bootstrap/Dropdown';
// import Icon from '../../../components/icon/Icon';
// import ThemeContext from '../../../contexts/themeContext';
// import LANG, {getLangWithKey} from '../../../lang';
// import showNotification from '../../../components/extras/showNotification';
// import useDarkMode from '../../../hooks/useDarkMode';
// import Popovers from '../../../components/bootstrap/Popovers';
//
// // eslint-disable-next-line react/prop-types
// const CommonHeaderRight = ({ beforeChildren, afterChildren }) => {
// 	const { darkModeStatus, setDarkModeStatus } = useDarkMode();
//
// 	const { fullScreenStatus, setFullScreenStatus } = useContext(ThemeContext);
// 	const styledBtn = {
// 		color: darkModeStatus ? 'dark' : 'light',
// 		hoverShadow: 'default',
// 		isLight: !darkModeStatus,
// 		size: 'lg',
// 	};
//
// 	const [notificationsList, setNotificationsList] = useState([]);
//
// 	const [offcanvasStatus, setOffcanvasStatus] = useState(false);
//
// 	const { i18n } = useTranslation();
//
// 	const changeLanguage = (lng) => {
// 		i18n.changeLanguage(lng);
// 		showNotification(
// 			<span className='d-flex align-items-center'>
// 				<Icon icon={getLangWithKey(lng)?.icon} size='lg' className='me-1' />
// 				<span>{`Language changed to ${getLangWithKey(lng)?.text}`}</span>
// 			</span>,
// 			'You updated the language of the app.',
// 		);
// 	};
//
// 	/**
// 	 * Language attribute
// 	 */
// 	useLayoutEffect(() => {
// 		document.documentElement.setAttribute('lang', i18n.language);
// 	});
//
// 	// useEffect(() => {
// 	// 	setNotificationsList([
// 	// 		{
// 	// 			notificationType: 'warning',
// 	// 			message: '',
// 	// 			actionButtonLabel: '',
// 	// 			actionButtonLink: '',
// 	// 			datetime: '',
// 	// 		},
// 	// 	]);
// 	// }, []);
//
// 	useEffect(() => {
// 		const timeout = setTimeout(() => {
// 			setNotificationsList([
// 				...notificationsList,
// 				{
// 					notificationType: 'info',
// 					message: '',
// 					actionButtonLabel: '',
// 					actionButtonLink: '',
// 					datetime: '',
// 				},
// 			]);
// 		}, 5000);
// 		return () => {
// 			clearTimeout(timeout);
// 		};
// 		// eslint-disable-next-line react-hooks/exhaustive-deps
// 	}, []);
//
// 	return (
// 		<HeaderRight>
// 			<div className='row g-3'>
// 				{beforeChildren}
// 				{/* Dark Mode */}
// 				<div className='col-auto'>
// 					<Popovers trigger='hover' desc='Dark / Light mode'>
// 						<Button
// 							// eslint-disable-next-line react/jsx-props-no-spreading
// 							{...styledBtn}
// 							icon={darkModeStatus ? 'DarkMode' : 'LightMode'}
// 							onClick={() => setDarkModeStatus(!darkModeStatus)}
// 							aria-label='Toggle fullscreen'
// 							data-tour='dark-mode'
// 						/>
// 					</Popovers>
// 				</div>
//
// 				{/*	Full Screen */}
// 				<div className='col-auto'>
// 					<Popovers trigger='hover' desc='Fullscreen'>
// 						<Button
// 							// eslint-disable-next-line react/jsx-props-no-spreading
// 							{...styledBtn}
// 							icon={fullScreenStatus ? 'FullscreenExit' : 'Fullscreen'}
// 							onClick={() => setFullScreenStatus(!fullScreenStatus)}
// 							aria-label='Toggle dark mode'
// 						/>
// 					</Popovers>
// 				</div>
//
// 				{/* Lang Selector */}
// 				<div className='col-auto'>
// 					<Dropdown>
// 						<DropdownToggle hasIcon={false}>
// 							<Button
// 								// eslint-disable-next-line react/jsx-props-no-spreading
// 								{...styledBtn}
// 								icon={getLangWithKey(i18n.language)?.icon}
// 								aria-label='Change language'
// 								data-tour='lang-selector'
// 							/>
// 						</DropdownToggle>
// 						<DropdownMenu isAlignmentEnd data-tour='lang-selector-menu'>
// 							{Object.keys(LANG).map((i) => (
// 								<DropdownItem key={LANG[i].lng}>
// 									<Button
// 										icon={LANG[i].icon}
// 										onClick={() => changeLanguage(LANG[i].lng)}>
// 										{LANG[i].text}
// 									</Button>
// 								</DropdownItem>
// 							))}
// 						</DropdownMenu>
// 					</Dropdown>
// 				</div>
//
// 				{/* Quick Panel */}
// 				<div className='col-auto'>
// 					<Dropdown>
// 						<DropdownToggle hasIcon={false}>
// 							{/* eslint-disable-next-line react/jsx-props-no-spreading */}
// 							<Button {...styledBtn} icon='Tune' aria-label='Quick menu' />
// 						</DropdownToggle>
// 						<DropdownMenu isAlignmentEnd size='lg' className='py-0 overflow-hidden'>
// 							<div className='row g-0'>
// 								<div
// 									className={classNames(
// 										'col-12',
// 										'p-4',
// 										'd-flex justify-content-center',
// 										'fw-bold fs-5',
// 										'text-info',
// 										'border-bottom border-info',
// 										{
// 											'bg-l25-info': !darkModeStatus,
// 											'bg-lo25-info': darkModeStatus,
// 										},
// 									)}>
// 									Quick Panel
// 								</div>
// 								<div
// 									className={classNames(
// 										'col-6 p-4 transition-base cursor-pointer bg-light-hover',
// 										'border-end border-bottom',
// 										{ 'border-dark': darkModeStatus },
// 									)}>
// 									<div className='d-flex flex-column align-items-center justify-content-center'>
// 										<Icon icon='Public' size='3x' color='info' />
// 										<span>Notifications</span>
// 										<small className='text-muted'>Options</small>
// 									</div>
// 								</div>
// 								<div
// 									className={classNames(
// 										'col-6 p-4 transition-base cursor-pointer bg-light-hover',
// 										'border-bottom',
// 										{ 'border-dark': darkModeStatus },
// 									)}>
// 									<div className='d-flex flex-column align-items-center justify-content-center'>
// 										<Icon icon='Upcoming' size='3x' color='success' />
// 										<span>Inbox</span>
// 										<small className='text-muted'>Configuration</small>
// 									</div>
// 								</div>
// 								<div
// 									className={classNames(
// 										'col-6 p-4 transition-base cursor-pointer bg-light-hover',
// 										'border-end',
// 										{ 'border-dark': darkModeStatus },
// 									)}>
// 									<div className='d-flex flex-column align-items-center justify-content-center'>
// 										<Icon icon='Print' size='3x' color='danger' />
// 										<span>Print</span>
// 										<small className='text-muted'>Settings</small>
// 									</div>
// 								</div>
// 								<div className='col-6 p-4 transition-base cursor-pointer bg-light-hover'>
// 									<div className='d-flex flex-column align-items-center justify-content-center'>
// 										<Icon icon='ElectricalServices' size='3x' color='warning' />
// 										<span>Export </span>
// 										<small className='text-muted'>Format</small>
// 									</div>
// 								</div>
// 							</div>
// 						</DropdownMenu>
// 					</Dropdown>
// 				</div>
//
// 				{/*	Notifications */}
// 				<div className='col-auto'>
// 					<Button
// 						// eslint-disable-next-line react/jsx-props-no-spreading
// 						{...styledBtn}
// 						icon='Notifications'
// 						className='btn-only-icon position-relative'
// 						onClick={() => setOffcanvasStatus(true)}
// 						aria-label='Notifications'>
// 						{notificationsList.length > 0 && (
// 							<Popovers desc='New Notifications' trigger='hover'>
// 								<span className='position-absolute top-30 start-70 translate-middle badge border border-light rounded-circle bg-danger p-2'>
// 									<span className='visually-hidden'>
// 										You Have New Notifications
// 									</span>
// 								</span>
// 							</Popovers>
// 						)}
// 					</Button>
// 				</div>
// 				{afterChildren}
// 			</div>
//
// 			<OffCanvas
// 				id='notificationCanvas'
// 				titleId='offcanvasExampleLabel'
// 				placement='end'
// 				isOpen={offcanvasStatus}
// 				setOpen={setOffcanvasStatus}>
// 				<OffCanvasHeader setOpen={setOffcanvasStatus}>
// 					<OffCanvasTitle id='offcanvasExampleLabel'>Notifications</OffCanvasTitle>
// 				</OffCanvasHeader>
// 				<OffCanvasBody>
// 					<Alert icon='description' isLight color='success' className='flex-nowrap'>
// 						In your work area last month 'sales per month' target met 78%. The previous
// 						month it was 75%.
// 						<div className='text-muted fs-6'>May 12, 2022 3:00 PM</div>
// 					</Alert>
// 					<Alert icon='local_shipping' isLight color='success' className='flex-nowrap'>
// 						Product A has been delivered
// 						<div className='text-muted fs-6'>May 12, 2022 3:00 PM</div>
// 					</Alert>
// 					<Alert icon='person' isLight color='info' className='flex-nowrap'>
// 						Product A has been assigned to delivery person: Jubair Ahmed. Estimated
// 						delivery date: April 14, 2022. Requisition ID: 12198
// 						<div className='text-muted fs-6'>May 12, 2022 3:00 PM</div>
// 					</Alert>
// 					<Alert icon='email' isLight color='info' className='flex-nowrap'>
// 						A new announcement has been made by the CEO.
// 						<div className='text-muted fs-6'>May 12, 2022 3:00 PM</div>
// 					</Alert>
// 					<Alert icon='person_add_alt' isLight color='info' className='flex-nowrap'>
// 						A new lead has been created in your work area. Lead name is Dr Sabbir Ahmed.
// 						<div className='text-muted fs-6'>May 12, 2022 3:00 PM</div>
// 					</Alert>
// 					<Alert icon='track_changes' isLight color='info' className='flex-nowrap'>
// 						Your sales per month (tk) target has been changed to 28,000 tk per month
// 						<div className='text-muted fs-6'>May 12, 2022 3:00 PM</div>
// 					</Alert>
// 					<Alert icon='inventory_2' isLight color='info' className='flex-nowrap'>
// 						A new requisition has been made for product A. Requisition ID is 12109.
// 						<div className='text-muted fs-6'>May 12, 2022 3:00 PM</div>
// 					</Alert>
// 					<Alert icon='inventory_2' isLight color='info' className='flex-nowrap'>
// 						A new requisition has been made for product A. Requisition ID is 12109.
// 						<div className='text-muted fs-6'>May 12, 2022 3:00 PM</div>
// 					</Alert>
// 					<Alert icon='inventory_2' isLight color='danger' className='flex-nowrap'>
// 						Please restock product A in your warehouse A.{' '}
// 						<div className='text-muted fs-6'>May 12, 2022 3:00 PM</div>
// 					</Alert>
// 					<Alert icon='inventory_2' isLight color='info' className='flex-nowrap'>
// 						Some products has been transferred from warehouse B. Transfer ID: 12109
// 						<div className='text-muted fs-6'>May 12, 2022 3:00 PM</div>
// 					</Alert>
// 					<Alert icon='description' isLight color='info' className='flex-nowrap'>
// 						10 new prescriptions have been uploaded in your work area by SPO Salim
// 						<div className='text-muted fs-6'>May 12, 2022 3:00 PM</div>
// 					</Alert>
// 					<Alert icon='location_on' isLight color='danger' className='flex-nowrap'>
// 						Sabbir ahmed (user id: 1298, mobile: 018281982198) uploaded a prescription
// 						from an invalid location.
// 						<div className='text-muted fs-6'>May 12, 2022 3:00 PM</div>
// 					</Alert>
// 				</OffCanvasBody>
// 			</OffCanvas>
// 		</HeaderRight>
// 	);
// };
// CommonHeaderRight.propTypes = {
// 	beforeChildren: PropTypes.node,
// 	afterChildren: PropTypes.node,
// };
// CommonHeaderRight.defaultProps = {
// 	beforeChildren: null,
// 	afterChildren: null,
// };
//
// export default CommonHeaderRight;
import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import Button from "../../../components/bootstrap/Button";
import { HeaderRight } from "../../../layout/Header/Header";
import Dropdown, { DropdownItem, DropdownMenu, DropdownToggle } from "../../../components/bootstrap/Dropdown";
import Icon from "../../../components/icon/Icon";
import ThemeContext from "../../../contexts/themeContext";
import LANG, { getLangWithKey } from "../../../lang";
import showNotification from "../../../components/extras/showNotification";
import useDarkMode from "../../../hooks/useDarkMode";
import Popovers from "../../../components/bootstrap/Popovers";
import { useNavigate } from "react-router-dom";
import { generateToken, messaging } from "../../../notification/firebase";
import { onMessage } from "firebase/messaging";
import useStore from "../../../hooks/useStore";
import Toasts from "../../../components/bootstrap/Toasts";
import { useToasts } from "react-toast-notifications";
import { baseUrl } from "../../../helpers/helpers";
import useData from "../../../hooks/useData";
// eslint-disable-next-line react/prop-types
const CommonHeaderRight = ({ beforeChildren, afterChildren }) => {
	const { darkModeStatus, setDarkModeStatus } = useDarkMode();
	const { addToast } = useToasts();
	const {token} = useData()

	const { fullScreenStatus, setFullScreenStatus } = useContext(ThemeContext);
	const styledBtn = {
		color: darkModeStatus ? 'dark' : 'light',
		hoverShadow: 'default',
		isLight: !darkModeStatus,
		size: 'lg',
	};
	const navigate = useNavigate()

	const { i18n } = useTranslation();

	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
		showNotification(
			<span className='d-flex align-items-center'>
				<Icon icon={getLangWithKey(lng)?.icon} size='lg' className='me-1' />
				<span>{`Language changed to ${getLangWithKey(lng)?.text}`}</span>
			</span>,
			'You updated the language of the app.',
		);
	};

	/**
	 * Language attribute
	 */
	useLayoutEffect(() => {
		document.documentElement.setAttribute('lang', i18n.language);
	});

	const {setFirebaseToken,notificationsList,setNotificationUpdate,notificationUpdate} = useStore()



	const [notificationCount,setNotificationCount] = useState(0)
	useEffect(() => {
		if (!token){
			return
		}
		const notificationCountGet = async ()=>{
			try {
				const res = await fetch(`${baseUrl.url}/api/unread_notification`, {
					method: 'GET',
					headers: {
						Authorization: `bearer ${token}`,
					},
				});
				const data = await res.json();
				if (res.ok) {
					setNotificationCount(data.data)
				}
			}catch (e) {
				console.log(e);
			}
		}
		notificationCountGet().then()
	}, [token,notificationUpdate]);


















	useEffect(() => {

		// Listen for foreground messages
		const unsubscribe = onMessage(messaging, (payload) => {
			const {title,body} = payload.notification
			setNotificationUpdate(!notificationUpdate)
			addToast(
				<Toasts title={title} icon='Info' iconColor='info' time='Now' isDismiss>
					{body}
				</Toasts>,
				{
					autoDismiss: true,
				},
			);
		});

		// Cleanup listener on unmount
		return () => unsubscribe();
	}, [notificationsList,notificationUpdate,addToast]);


















	return (
		<HeaderRight>
			<div className='row g-3'>
				{beforeChildren}
				{/* Dark Mode */}
				<div className='col-auto'>
					<Popovers trigger='hover' desc='Dark / Light mode'>
						<Button
							// eslint-disable-next-line react/jsx-props-no-spreading
							{...styledBtn}
							icon={darkModeStatus ? 'DarkMode' : 'LightMode'}
							onClick={() => setDarkModeStatus(!darkModeStatus)}
							aria-label='Toggle fullscreen'
							data-tour='dark-mode'
						/>
					</Popovers>
				</div>

				{/*	Full Screen */}
				<div className='col-auto'>
					<Popovers trigger='hover' desc='Fullscreen'>
						<Button
							// eslint-disable-next-line react/jsx-props-no-spreading
							{...styledBtn}
							icon={fullScreenStatus ? 'FullscreenExit' : 'Fullscreen'}
							onClick={() => setFullScreenStatus(!fullScreenStatus)}
							aria-label='Toggle dark mode'
						/>
					</Popovers>
				</div>

				{/* Lang Selector */}
				<div className='col-auto'>
					<Dropdown>
						<DropdownToggle hasIcon={false}>
							<Button
								// eslint-disable-next-line react/jsx-props-no-spreading
								{...styledBtn}
								icon={getLangWithKey(i18n.language)?.icon}
								aria-label='Change language'
								data-tour='lang-selector'
							/>
						</DropdownToggle>
						<DropdownMenu isAlignmentEnd data-tour='lang-selector-menu'>
							{Object.keys(LANG).map((i) => (
								<DropdownItem key={LANG[i].lng}>
									<Button
										icon={LANG[i].icon}
										onClick={() => changeLanguage(LANG[i].lng)}>
										{LANG[i].text}
									</Button>
								</DropdownItem>
							))}
						</DropdownMenu>
					</Dropdown>
				</div>

				{/* Quick Panel */}
				<div className='col-auto'>
					<Dropdown>
						<DropdownToggle hasIcon={false}>
							{/* eslint-disable-next-line react/jsx-props-no-spreading */}
							<Button {...styledBtn} icon='Tune' aria-label='Quick menu' />
						</DropdownToggle>
						<DropdownMenu isAlignmentEnd size='lg' className='py-0 overflow-hidden'>
							<div className='row g-0'>
								<div
									className={classNames(
										'col-12',
										'p-4',
										'd-flex justify-content-center',
										'fw-bold fs-5',
										'text-info',
										'border-bottom border-info',
										{
											'bg-l25-info': !darkModeStatus,
											'bg-lo25-info': darkModeStatus,
										},
									)}>
									Quick Panel
								</div>
								<div
									className={classNames(
										'col-6 p-4 transition-base cursor-pointer bg-light-hover',
										'border-end border-bottom',
										{ 'border-dark': darkModeStatus },
									)}>
									<div className='d-flex flex-column align-items-center justify-content-center'>
										<Icon icon='Public' size='3x' color='info' />
										<span>Notifications</span>
										<small className='text-muted'>Options</small>
									</div>
								</div>
								<div
									className={classNames(
										'col-6 p-4 transition-base cursor-pointer bg-light-hover',
										'border-bottom',
										{ 'border-dark': darkModeStatus },
									)}>
									<div className='d-flex flex-column align-items-center justify-content-center'>
										<Icon icon='Upcoming' size='3x' color='success' />
										<span>Inbox</span>
										<small className='text-muted'>Configuration</small>
									</div>
								</div>
								<div
									className={classNames(
										'col-6 p-4 transition-base cursor-pointer bg-light-hover',
										'border-end',
										{ 'border-dark': darkModeStatus },
									)}>
									<div className='d-flex flex-column align-items-center justify-content-center'>
										<Icon icon='Print' size='3x' color='danger' />
										<span>Print</span>
										<small className='text-muted'>Settings</small>
									</div>
								</div>
								<div className='col-6 p-4 transition-base cursor-pointer bg-light-hover'>
									<div className='d-flex flex-column align-items-center justify-content-center'>
										<Icon icon='ElectricalServices' size='3x' color='warning' />
										<span>Export </span>
										<small className='text-muted'>Format</small>
									</div>
								</div>
							</div>
						</DropdownMenu>
					</Dropdown>
				</div>

				{/*	Notifications ==================================================================================================================*/}
				<div className='col-auto'>
					<Button
						// eslint-disable-next-line react/jsx-props-no-spreading
						{...styledBtn}
						icon='Notifications'
						className='btn-only-icon position-relative'
						onClick={() => navigate("/settings/notification")}
						aria-label='Notifications'>
						<div style={{height:'15px',width:'15px'}} className='position-absolute d-flex align-items-center justify-content-center text-white top-30 start-70 translate-middle rounded-circle bg-danger'>
									<span style={{fontSize:8}}>
										{notificationCount}
									</span>
						</div>
					</Button>
				</div>
				{afterChildren}
			</div>
		</HeaderRight>
	);
};
CommonHeaderRight.propTypes = {
	beforeChildren: PropTypes.node,
	afterChildren: PropTypes.node,
};
CommonHeaderRight.defaultProps = {
	beforeChildren: null,
	afterChildren: null,
};

export default CommonHeaderRight;
